module.exports = __webpack_public_path__ + "static/img/dana.b9941ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/dana.png
// module id = zZMt
// module chunks = 0